import { BaseEntity, InlineContainerService } from 'yt-ng-framework';
import { Component } from "@angular/core";
import { BaseInlineUpdateComponent } from 'yt-ng-framework';
import { OsnovZaPravoNaGo } from './osnov-za-pravo-na-go';

@Component({
    selector: 'yt-osnov-za-pravo-na-go-inline-update',
    templateUrl: './osnov-za-pravo-na-go-inline-update.component.html'
})
export class OsnovZaPravoNaGoInlineUpdateComponent
 extends BaseInlineUpdateComponent<OsnovZaPravoNaGo> {
    constructor(protected inlineContainerService: InlineContainerService<OsnovZaPravoNaGo>){
        super(inlineContainerService);
    }
}
